module.exports = new __parcel__URL__("5.e3197081.webp").toString();